export const convertToId = (str: string) => str.split(' ').join('').toLowerCase();
